.container {
  max-width: 172.8rem;
  margin: auto;
  width: 100%;
  padding: 0 3.6rem;
}
